/**
 * Кроссбраузерное открытие ссылки в новой вкладке.
 * Учитывает особенности iOS (задержка) и Safari (симуляция клика).
 * Всегда использует noopener,noreferrer для защиты от tab-napping.
 *
 * Это общий модуль для всех семейств лендингов — точка будущей интеграции
 * трекера Спринта 1 (offer_click / offer_redirect).
 */
export function openLink(url) {
  const ua = navigator.userAgent;
  const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  const isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

  if (isChrome || isFirefox) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  if (isIOS) {
    setTimeout(() => window.open(url, '_blank', 'noopener,noreferrer'), 100);
    return;
  }

  if (isSafari) {
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('target', '_blank');
    a.setAttribute('rel', 'noopener noreferrer');
    a.click();
    a.remove();
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
